import registry from '~/library/store/src/registry';
import * as types from './action-types';
import dashboardState from './initial-state';
import * as operations from './operations';

export default function reducer(state = dashboardState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case `${types.GET_AVAILABLE_OPTIONS_FOR_ORDER}_SUCCESS`:
      return {
        ...state,
        ...payload,
        availableOptions: payload
      };

    case `${types.GET_CASE_DEFAULTS}_SUCCESS`:
      return {
        ...state,
        status: {
          ...state.status,
          caseId: payload?.caseId
        }
      };

    case `${types.ORDER_SUMMARY_FETCH}_LOADING`:
      return {
        ...state,
        orderSummary: {
          ...state.orderSummary,
          hasLoaded: false
        }
      };

    case `${types.ORDER_SUMMARY_FETCH}_SUCCESS`: {
      const vehicle = payload?.vehicle;

      return {
        ...state,
        orderSummary: {
          ...payload,
          hasLoaded: true,
          status: operations.setDashboardModuleStatus({ isComplete: true })
        },
        vehicle: {
          ...vehicle,
          srcImageUrl: operations.getVehicleImageUrl(vehicle?.stockNumber),
          closeUpSrcImageUrl: operations.getCloseUpVehicleImageUrl(
            vehicle?.stockNumber
          )
        }
      };
    }
    case `${types.GET_DASHBOARD_NO_LOADING_INDICATOR}_LOADING`:
      return {
        ...state,
        isLoading: false
      };

    case `${types.GET_DASHBOARD}_LOADING`:
    case `${types.START_PURCHASE_WITH_VEHICLE_ID}_LOADING`: {
      return {
        ...state,
        isLoading: true
      };
    }
    case types.UPDATE_DASHBOARD_COMPLETE: {
      return {
        ...state,
        hasDashboardRun: true
      };
    }

    case `${types.GET_DASHBOARD}_SUCCESS`:
    case `${types.GET_DASHBOARD_NO_LOADING_INDICATOR}_SUCCESS`:
    case `${types.START_PURCHASE_WITH_VEHICLE_ID}_SUCCESS`:
    case `${types.SWITCH_VEHICLE}_SUCCESS`: {
      const { vehicle: ignoredVehicle, ...rest } = payload || {};
      const status = rest?.status;

      return {
        ...state,
        ...rest,
        isLoading: false,
        isError: false,
        error: null,
        isCancelInProcess: false,
        status: {
          ...state.status,
          ...status
        }
      };
    }

    case `${types.START_PURCHASE_WITH_VEHICLE_ID}_ERROR`:
      return {
        ...state,
        isLoading: false
      };

    case `${types.GET_DASHBOARD}_ERROR`:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: payload
      };

    case `${types.PAUSE_LOCK_TIMER}_LOADING`:
      return {
        ...state,
        vehicleLock: dashboardState.vehicleLock
      };

    case `${types.PAUSE_LOCK_TIMER}_SUCCESS`:
      return {
        ...state
      };

    case `${types.PAUSE_LOCK_TIMER}_ERROR`:
      return {
        ...state
      };

    case `${types.SWITCH_VEHICLE}_LOADING`:
    case `${types.CANCEL_CURRENT_PURCHASE}_LOADING`: {
      return {
        ...state,
        isLoading: true,
        isCancelInProcess: true
      };
    }
    case `${types.GET_OPD_NOTIFICATIONS}_SUCCESS`:
      return {
        ...state,
        notifications: {
          ...payload,
          hasNotification: Object.keys(payload).length !== 0
        }
      };

    case `${types.GET_PAYMENT_SUMMARY}_SUCCESS`:
      return {
        ...state,
        paymentSummary: payload
      };

    default:
      return state;
  }
}

registry.register('dashboard', reducer, dashboardState);
